import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { NextPage } from 'next';
import { NextSeo } from 'next-seo';
import { useRouter } from 'next/router';
import SupportTemplate from '@components/CartSupport/Support';
import FooterTemplate from '@components/Footer/Footer';
import HeaderTemplate from '@components/Header/Header';
import LoginTemplate from '@components/Login/Login';
import useTranslation from '@hooks/useTranslation';
import ContentTemplate from '@ui/Content/Content';
import { publicAssets } from '@utils/url.utils';
import Cookies from 'js-cookie';
import { ACCESS_TOKEN_KEY, IS_PROD, ROUTES } from '../constants';
import { RootState } from '../store';

interface ILogin {}

const Login: NextPage<ILogin> = () => {
    const { t } = useTranslation();

    const router = useRouter();

    const isLoggedInState = useSelector((state: RootState) => state.ui.isLoggedIn);

    const [isLoggedIn, setIsLoggedIn] = useState(false);

    useEffect(() => {
        console.log('TOKEN', isLoggedIn, isLoggedInState, Cookies.get(ACCESS_TOKEN_KEY));

        if (!isLoggedIn && isLoggedInState) {
            setIsLoggedIn(isLoggedInState);

            router.replace({
                pathname: ROUTES.SHOP_PARTICIPANTS,
            });
        }
    }, [isLoggedInState]);

    return (
        <>
            <NextSeo
                title={t('seo.login.title')}
                description={t('seo.login.description')}
                noindex={!IS_PROD}
                nofollow={!IS_PROD}
                openGraph={{
                    images: [{ url: `https://profivzdelavanie.sk${publicAssets('/og-konferencia.png')}` }],
                }}
            />
            <HeaderTemplate />
            <ContentTemplate withPadding sidePadding={20}>
                <LoginTemplate />
                <SupportTemplate />
            </ContentTemplate>
            <FooterTemplate />
        </>
    );
};

export default Login;
